


























































import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import TextDatePicker from '@/views/molecules/TextDatePicker.vue'
import moment from 'moment'
import store from '@/store'
import Global from '@/common/global.js'
import TextArea from '@/views/atoms/TextArea.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import PopupComfirmEdit from '@/views/template/PopupComfirmEdit.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    BlueButton
    TextBox
    SelectBox
    TextDatePicker
    TextArea
    BackButton
    PopupComfirmSave
    PopupComfirmEdit
    ErrorLabel
    PopupComplete
  }

  data: () ->
    date: moment().format('yyyy-MM-DD')
    containerTypeList: Global.containerType()
    capacityList: Global.capacity()
    defaultContainerType: '1'
    defaultCapacity: '3'
    paramsId: false
    supplySourceList: Global.supplySource()
    defaultSupplySource: store.getters.getAdminData.supply_source
    defaultLaboratory: '0'
    toyonakaLaboratory: []
    suitaLaboratory: []
    isShowPopup: {}
    disabled: false
    id: ''
    complete: ''
    level: store.getters.getAdminData.level

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    api = new ApiClient();
    names = await api.get('/admin/user/name_list')
    list = names.list
    @toyonakaLaboratory.push(
      id: '0'
      name: ''
    )
    @suitaLaboratory.push(
      id: '0'
      name: ''
    )
    for row, key in list
      if row.supply_source == '1'
        @toyonakaLaboratory.push(
          id: row.id
          name: row.name
        )
      if row.supply_source == '2'
        @suitaLaboratory.push(
          id: row.id
          name: row.name
        )

    if @.$route.params.id > 0
      @paramsId = true
      api = new ApiClient()
      data = await api.get('/admin/reserve/detail/' + @.$route.params.id)
      if data.detail.id == ''
        @$router.push '/admin/top'
      @id = data.detail.id
      @defaultContainerType = String(data.detail.container_type)
      @defaultCapacity = String(data.detail.capacity)
      @defaultSupplySource = String(data.detail.supply_source)
      @defaultLaboratory = String(data.detail.user_id)
      store.dispatch('setDetailParam', data)
    else
      if moment(@.$route.params.date).isValid() && moment().isSameOrBefore(@.$route.params.date, 'day')
        data = {
          detail: {
            desired_supply_date: moment(@.$route.params.date).format('yyyy-MM-DD')
          }
        }
        @disabled = true
        store.dispatch('setDetailParam', data)
      else
        @$router.push '/admin/top'

  methods: {
    dateChange: (param) ->
      # if param.val < @date
        # console.log store.getters.getPostParam.desired_supply_date
        # @v = ''
    save_click: () ->
      postParam = store.getters.getPostParam
      if postParam.laboratory_name == '0'
        user_id = ''
      else
        user_id = postParam.laboratory_name
      param = 
        user_id: user_id
        name: postParam.name,
        desired_supply_date: postParam.desired_supply_date,
        container_type: postParam.container_type,
        capacity: postParam.capacity,
        remarks: postParam.remarks,
        private_remarks: postParam.private_remarks,
        supply_source: postParam.supply_source,
      api = new ApiClient()
      data = await api.post('/admin/reserve/save', param)
      if data.errors.length == 0
        @complete = '登録'
        @showPopup('complete')
      @closePopup('save')
    edit_click: () ->
      postParam = store.getters.getPostParam
      param = 
        id: @id,
        user_id: postParam.laboratory_name,
        name: postParam.name,
        desired_supply_date: postParam.desired_supply_date,
        container_type: postParam.container_type,
        capacity: postParam.capacity,
        remarks: postParam.remarks,
        private_remarks: postParam.private_remarks,
        supply_source: postParam.supply_source,
      api = new ApiClient()
      data = await api.post('/admin/reserve/save', param)
      if data.errors.length == 0
        @complete = '変更'
        @showPopup('complete')
      @closePopup('save')
    back: () ->
      @$router.push '/admin/top'
    change: (v) ->
      @defaultSupplySource = v.val
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    moveTopPage: () ->
      @$router.push '/admin/top'
  }
